import { render, staticRenderFns } from "./OurActivity.vue?vue&type=template&id=1bc95882&scoped=true&"
import script from "./OurActivity.vue?vue&type=script&lang=js&"
export * from "./OurActivity.vue?vue&type=script&lang=js&"
import style0 from "./OurActivity.vue?vue&type=style&index=0&id=1bc95882&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc95882",
  null
  
)

export default component.exports